import * as Fuse from 'fuse.js';

const getSearchKeys = (searchType: string) => {
  const searchKeys = {
    productResults: [
      "name_common",
      "name_scientific",
      "species",
      "genus",
      "cultivar",
    ],
    nurseryResults: [
      "name",
      "address",
      "city",
      "contact_name",
      "email",
    ],
  };
  return searchKeys[searchType] || [];
}
const getDataWithSearch = (searchText: string, searchKeys: Array<string>,  dataToSearch: Array<any>) => {
  const fuseOptionsNurseryData = {
    shouldSort: true,
    includeScore: true,
    // includeMatches: true,
    threshold: 0.2,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: searchKeys
  };
  const fuseSearch = new Fuse(dataToSearch, fuseOptionsNurseryData).search(searchText);
  return fuseSearch;
}
const getDataWithSearchLowThresh = (searchText: string, searchKeys: Array<string>,  dataToSearch: Array<any>) => {
  const fuseOptionsNurseryData = {
    shouldSort: true,
    includeScore: true,
    includeMatches: true,
    threshold: 0.4,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: searchKeys
  };
  const fuseSearch = new Fuse(dataToSearch, fuseOptionsNurseryData).search(searchText);
  return fuseSearch;
}

const getBestScoreFromResults = (searchResults: any, dataSetKeys: Array<string>) => {
  let keyWithBestScore = dataSetKeys[0]; // default
  let bestScore = 1;
  dataSetKeys.map((key) => {
    if (!searchResults[key][0]) return;
    if (searchResults[key][0].score < bestScore) { // bestScore is updated if it beats it.
      bestScore = searchResults[key][0].score;
      keyWithBestScore = key;
    }
  });
  return keyWithBestScore;
}

const determineSearchTypeAndData = (searchText: string, dataSets: any) => {
  const dataSetKeys = Object.keys(dataSets);
  const searchResults = {
    keyWithBestScore: dataSetKeys[0],
  };
  dataSetKeys.map((key) => {
    searchResults[key] = getDataWithSearch(searchText, getSearchKeys(key), dataSets[key]);
  });
  searchResults.keyWithBestScore = getBestScoreFromResults(searchResults, dataSetKeys);
  searchResults['resultsData'] = searchResults[searchResults.keyWithBestScore];
  // searchResults.keyWithBestScore = 'nurseryResults';
  // searchResults['resultsData'] = searchResults[searchResults.keyWithBestScore];
  if (searchResults['resultsData'].length == 0) {
    dataSetKeys.map((key) => {
      searchResults[key] = getDataWithSearchLowThresh(searchText, getSearchKeys(key), dataSets[key]);
    });
    // searchResults.keyWithBestScore = 'nurseryResults';
    // searchResults['resultsData'] = searchResults[searchResults.keyWithBestScore];
    searchResults.keyWithBestScore = getBestScoreFromResults(searchResults, dataSetKeys);
    searchResults['resultsData'] = searchResults[searchResults.keyWithBestScore];
  }
  return searchResults;
};

const getFuseResultOfSearchTerm = (stringsToCompare: Array<string>, comparisonString: string, searchKeys: Array<any>) => {
  const fuseOptionsNurseryData = {
    shouldSort: true,
    includeScore: true,
    threshold: .5,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: searchKeys
  };
  const fuseSearch = new Fuse(stringsToCompare, fuseOptionsNurseryData).search(comparisonString);
  return fuseSearch;
}


export function transformNurseryDataLatLong (nursery: any) {
  //comes in as csv, return object
  let latLongArray = nursery.lat_long.split(',');
  nursery.lat_long = {latitude: parseInt(latLongArray[0], 10), longitude: parseInt(latLongArray[1], 10)};
  return nursery;
}
export function getSearchResults(searchText: string, dataSetsToSend: any) {
  return determineSearchTypeAndData(searchText, dataSetsToSend);
}
export function getProductSearchKeys() {
  return getSearchKeys('productResults');
}
export function getNurserySearchKeys() {
  return getSearchKeys('nurseryResults');
}
export function getNameWithCloserMatch(stringsToCompare: Array<string>, searchTerm) {
  const searchArray = [];
  stringsToCompare.map((stringToCompare => searchArray.push({ name: stringToCompare })))
  const results: any = getFuseResultOfSearchTerm(searchArray, searchTerm, ['name']);
  return results.length > 0 ? results[0].item.name : stringsToCompare[0];
}
